import { handleErrors } from "@/utils/handle-errors";
import { SdkEnvironment } from "@/interfaces/sdk-environment";
import fetch from "@mv/flow-shared-utils/functions/fetch";
import { Context } from "@/interfaces/sdk";
import { tokenInfo } from "@/store/login/types";
export const saveEnvironment = (environment: SdkEnvironment) => ({ type: "saveEnvironment", environment });
export const updateEnvironment = (environment: SdkEnvironment) => ({ type: "updateEnvironment", environment });
export const loadAllEnvironment = () => ({ type: "loadAllEnvironment" });
export const loadEnvironment = (environmentId: number) => ({ type: "loadEnvironment", environmentId });
export const loadEnvironmentByCompany = (companyId: number) => ({ type: "loadEnvironmentByCompany", companyId });
export const loadEnvironmentByCompanyAndUser = (companyId: number, user: string) => ({ type: "loadEnvironmentByCompanyAndUser", companyId, user });
export const deleteEnvironment = (environmentId: number) => ({ type: "deleteEnvironment", environmentId });
export const loadEnvironmentsByRole = (role: string) => ({ type: "loadEnvironmentsByRole", role });
export const getEnvironmentId = () => ({ type: "getEnvironmentId" });

export const actions = {
  loadAllEnvironment() {
    return fetch(`core/api/environment`)
      .then(handleErrors)
      .then((data) => data);
  },

  loadEnvironment(context: any, { environmentId }: { environmentId: number }) {
    return fetch(`core/api/environment/${environmentId}`)
      .then(handleErrors)
      .then((data) => data);
  },

  loadEnvironmentByCompany(context: any, { companyId }: { companyId: number }) {
    return fetch(`core/api/environment/company/id/${companyId}`)
      .then(handleErrors)
      .then((data) => data);
  },

  loadEnvironmentByCompanyAndUser(context: any, { companyId, user }: { companyId: number; user: string }) {
    return fetch(`core/api/environment/company/id/${companyId}?user=${user}`)
      .then(handleErrors)
      .then((data) => data);
  },

  saveEnvironment(state: any, { environment }: { environment: SdkEnvironment }) {
    return fetch(`core/api/environment`, {
      method: "POST",
      body: JSON.stringify(environment),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  updateEnvironment(state: any, { environment }: { environment: SdkEnvironment }) {
    return fetch(`core/api/environment`, {
      method: "PUT",
      body: JSON.stringify(environment),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  deleteEnvironment(context: any, { environmentId }: { environmentId: number }) {
    return fetch(`core/api/environment/${environmentId}`, {
      method: "DELETE",
    }).then(handleErrors);
    // .then((data) => data);
  },

  loadEnvironmentsByRole(context: any, { role }: { role: string }) {
    return fetch(`flow/api/category/user/role/${role}`)
      .then(handleErrors)
      .then(({ data }) => data)
      .catch((err) => {
        throw err;
      });
  },

  getEnvironmentId(context: Context) {
    const environmentId = (context.rootGetters[tokenInfo] as any).environment.id;
    return environmentId;
  },
};
